import { Plan } from '../plan.dto';
import { InspectionCase } from './inspection-cases';
import { Cases, Inspection } from './inspection.dto';

export class PlanningDetailsDto extends InspectionCase {
  plans?: Plan[];
}
export class PlanningDetails extends PlanningDetailsDto implements Inspection {
  constructor(data: PlanningDetailsDto = { title: 'רשימת המסמכים' }) {
    super(data);
    this.plans =
      data.plans && data.plans.length > 0
        ? data.plans.map((plan) => new Plan(plan))
        : [];
    this.setInspectionStatus();
  }

  setInspectionStatus(): void {
    this.isPassed = !this.isApplicable || this._isPassed();
  }

  getCases(): Cases[] {
    return [];
  }

  private _isPassed(): boolean {
    return !this.plans.find((p) => p.isPassed === false);
  }
}
